import VehiclePanel from './VehiclePanel';

export default VehiclePanel;
